const Mission = () =>
<section id="mission" className="py-16 md:py-24 bg-warm-cream">
    <div className="container mx-auto">
      <div>
        <h2 className="text-4xl md:text-5xl font-semibold font-display text-gray-900">Why I do this</h2>
        <p className="mt-3 text-lg md:text-xl text-gray-700 max-w-prose">I'm Andres Ravinet. I started AI Montclair because I kept seeing good Montclair businesses stuck doing the same repetitive work every week — answering the same emails, chasing the same no-shows, losing leads because nobody followed up fast enough.</p>
        <p className="mt-4 text-lg md:text-xl text-gray-700 max-w-prose">
          That's fixable. I build automation systems that handle the busy work so you can focus on what actually grows your business. No jargon, no bloated agency contracts. Just a neighbor who knows the tools and gets it done.
        </p>
      </div>
    </div>
  </section>;


export default Mission;